export function createEmitter(scene: any) {
  return scene.add.particles(0, 0, "particle", {
    speed: { min: 50, max: 200 },
    scale: { start: 1, end: 0 },
    alpha: { start: 1, end: 0 },
    lifespan: { min: 300, max: 600 },
    emitting: false,
  });
}

export function explode(emitter: any, x: number, y: number, color: number, count: number) {
  if (!emitter) return;
  emitter.setParticleTint(color);
  emitter.explode(count, x, y);
}
